import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-heart-bullet',
  templateUrl: './heart-bullet.component.html',
  styleUrls: ['./heart-bullet.component.css']
})
export class HeartBulletComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
